import React from 'react';
import { useLocation } from 'react-router-dom';
import Header from "../../components/ChooseSection/Navbar/Header";
import Footer from "../../components/Footer/Footer";
const PaymentFailure = () => {

  const location = useLocation();
    const { error } = location.state || {};

  return (

    <div className="student-page">
                <Header />
                <header className="height-75">
                    <div className="container h-100 d-flex flex-column align-items-center justify-content-center text-light">
                        <h1 className="text-center fw-semibold">Payment Failure!</h1>
                    </div>
                </header>
    <div className="container mt-5">
      <h2>❌ Payment Failed</h2>
      <p>{error || "Something went wrong with your payment."}</p>
      <p>Please try again or contact support.</p>
    </div>
<Footer/>
    </div>
  );
};

export default PaymentFailure;
